import { DATABASE_TYPE } from './types';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PER_PAGE_OPTIONS = [30, 50, 100];

export const DEFAULT_FILTER_TYPE = 'ALL';
export const DEFAULT_FILTER_TYPE_OPTIONS = [
  { label: '전체', value: 'ALL' },
  { label: '제조', value: DATABASE_TYPE.MANUFACTURE },
  { label: '포장', value: DATABASE_TYPE.PACKAGE },
];
